import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { asyncConnect, withSagas } from 'react-async-client';
import { Spin, Layout } from 'antd';
import { path } from 'ramda';

import { authLogoutSaga } from 'sagas/links';
import Modals from 'components/Modals';
import ErrorHTML from 'components/common/form/ErrorHTML';
import { getCompanyInfo, getMetroAuth, getMetroRequestLink, getUser } from 'actions/asyncActions';
import { saveBackUrl } from 'actions/userActions';
import MetroRequest from 'components/views/metro/request/MetroRequest';
import TopMenu from 'components/layout/user/TopMenu';

@asyncConnect({
    getUser,
    getMetroRequestLink,
    getMetroAuth: getMetroAuth
        .withOptions({ dispatchOnMount: true })
        .withSuccessHandler(({ getMetroRequestLink, authKey }) => {
            getMetroRequestLink.dispatch({ authKey });
        }),
})
@withSagas([
    authLogoutSaga
])
class MetroRequestApproval extends Component {
    static propTypes = {
        authKey: PropTypes.string.isRequired,
        getUser: PropTypes.object.isRequired,
        getMetroAuth: PropTypes.object.isRequired,
        getMetroRequestLink: PropTypes.object.isRequired,
    }

    render() {
        const { authKey } = this.props;
        const { meta : userMeta } = this.props.getUser;
        const { meta : authMeta } = this.props.getMetroAuth;
        const { meta, data } = this.props.getMetroRequestLink;
        const id = path(['nextCommand', 'id'], data);
        const role = path(['nextCommand', 'addparam1'], data) || 3;

        return (
            <Fragment>
                <Spin className='scenario-spin' spinning={meta.pending || authMeta.pending}>
                    <div className="scenario-layout">
                        <TopMenu noUser={true} />
                        <Layout>
                            <ErrorHTML meta={authMeta} />
                            <ErrorHTML meta={meta} />
                            { userMeta.success ? (
                                <Fragment>
                                    <ErrorHTML meta={{ error: { translate: 'error.6' } }} />
                                </Fragment>
                            ) : meta.success && authMeta.success && (
                                <MetroRequest
                                    match={{ params: { id } }}
                                    approvalRole={role}
                                    authKey={authKey}
                                />
                            )}
                        </Layout>
                    </div>
                </Spin>

                <Modals />
            </Fragment>
        );
    }
}

@asyncConnect({
    getMetroRequestLink,
    getUser: getUser
        .withOptions({ dispatchOnMount: true })
        .withSuccessHandler(({ getMetroRequestLink, authKey }) => {
            getMetroRequestLink.dispatch({ authKey });
        })
        .withErrorHandler(({ history, location, saveBackUrl }) => {
            saveBackUrl(`${location.pathname}${location.search}`);
            history.push('/login');
        }),
})
class MetroAuthRequestApproval extends Component {
    static propTypes = {
        authKey: PropTypes.string.isRequired,
        getUser: PropTypes.object.isRequired,
        getMetroRequestLink: PropTypes.object.isRequired,
    }

    render() {
        const { authKey } = this.props;
        const { meta : userMeta } = this.props.getUser;
        const { meta, data } = this.props.getMetroRequestLink;
        const id = path(['nextCommand', 'id'], data);
        const role = path(['nextCommand', 'addparam1'], data) || 3;

        return (
            <Fragment>
                <Spin className='scenario-spin' spinning={meta.pending || userMeta.pending}>
                    <div className="scenario-layout">
                        <TopMenu noUser={true} />
                        <Layout>
                            <ErrorHTML meta={userMeta} />
                            <ErrorHTML meta={meta} />
                            { meta.success && userMeta.success && (
                                <MetroRequest
                                    match={{ params: { id } }}
                                    approvalRole={role}
                                    authKey={authKey}
                                />
                            )}
                        </Layout>
                    </div>
                </Spin>

                <Modals />
            </Fragment>
        );
    }
}

const MetroRequestApprovalView = props => {
    const isSSO = (props.getCompanyInfo.data || {}).sso;
    const authKey = qs.parse(props.location.search, { ignoreQueryPrefix: true }).authKey;

    return isSSO ? (
        <MetroRequestApproval key={authKey} authKey={authKey} {...props} />
    ) : props.getCompanyInfo.pending ? null : <MetroAuthRequestApproval key={authKey} authKey={authKey} {...props} />;
};

export default asyncConnect({
    getCompanyInfo: getCompanyInfo
        .withOptions({ dispatchOnMount: true })
}, undefined, { saveBackUrl })(MetroRequestApprovalView);
